module.exports = {
  internalOnly: process.env.GATSBY_GRAPHITE_INTERNAL!=='false'
};